import {
  removeClass,
  toggleClass,
  hasClass,
  nodesToArray,
} from '../utils/helpers'

const toggleSelector = '.js-searchToggle'
const formSelector = '.js-searchForm'
const inputSelector = '.js-searchInput'
const closeSelector = '.js-searchClose'
const canvasSelector = '.js-offCanvas'
const activeClass = 'is-active'

export default class {
  constructor(el, options) {
    this.el = el
    this.form = this.el.querySelector(formSelector)
    this.searchField = this.form.querySelector(inputSelector)
    this.offCanvas = document.querySelector(canvasSelector)

    const toggleButtons = nodesToArray(
      document.querySelectorAll(toggleSelector),
    )
    const closeButton = this.el.querySelector(closeSelector)

    options = this.options = Object.assign({}, this.options, options)

    toggleButtons.forEach((toggleButton) => {
      toggleButton.addEventListener('click', this.onClick.bind(this), false)
    })

    this.searchField.addEventListener(
      'keydown',
      this.onKeydown.bind(this),
      false,
    )
    closeButton.addEventListener('click', this.onClose.bind(this), false)
  }

  /**
   * [onClick description]
   * @param {Object} e - Click event
   */
  onClick(e) {
    if (e.metaKey || e.ctrlKey) {
      return
    }

    this.toggleSearch()

    e.preventDefault()
  }

  /**
   * onKeydown
   * @param {Object} e
   */
  onKeydown(e) {
    if (e.key === 'Escape') {
      // Esc
      this.toggleSearch(false)
    } else if (e.key === 'Enter') {
      // Enter
      if (e.metaKey || e.ctrlKey) {
        // Open search in new tab
        window.open(
          window.location.protocol +
            '//' +
            document.location.host +
            '?s=' +
            e.target.value,
          '_blank',
        )
      } else {
        this.form.requestSubmit()
      }

      e.preventDefault()
    }
  }

  /**
   * Toggle navigation
   * @param newState   (true = open, false = close)
   */
  toggleSearch(newState) {
    const isActive = this.isActive()

    newState = typeof newState === 'boolean' ? newState : !isActive

    // Close off-canvas if active
    if (newState === true) {
      removeClass(this.offCanvas, activeClass)
    }

    toggleClass(this.el, activeClass, newState)

    if (!isActive) {
      this.searchField.select()
    }
  }

  /**
   * On close
   * @param  {Object} e
   */
  onClose(e) {
    this.toggleSearch(false)

    e.preventDefault()
  }

  /**
   * Check if active (has the activeClass set)
   */
  isActive() {
    return hasClass(this.el, activeClass)
  }
}
